import { createContext } from "react";
const ProductMultipageContext = createContext({});
export default ProductMultipageContext;
